'use client';

import { Me } from '@/interfaces/accounts';
import { Language } from '@/interfaces/general';
import { createContext, use, ReactNode } from 'react';

type UserSessionData = {
  me: Me | null;
  jwt: string | null;
  language: Language;
};

const AppContext = createContext<UserSessionData>({
  me: null,
  jwt: null,
  language: 'en_US',
});

const AppProvider = (props: { children: ReactNode } & UserSessionData) => {
  const contextValue = {
    me: props.me,
    jwt: props.jwt,
    language: props.language,
  };

  return <AppContext.Provider value={contextValue}>{props.children}</AppContext.Provider>;
};

const useAppContext = () => {
  const context = use(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

export { AppContext, AppProvider, useAppContext };
